import React, { FormEvent } from "react";
import { Row, Col, Form } from "react-bootstrap";
import "../../sass/main.scss";
import "./FormField.scss";

interface TextFieldProps {
    label?: string,
    name?: string,
    placeholder?: string,
    required?: boolean,
    errMsg?: string,
    maxLength?: number
    onChange: (value: string) => void,
    value?: string
    showError?: boolean,
    disabled?: boolean
    onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    className?: string,
    multiline?: boolean,
    suppressEnterSubmit?: boolean
}

export default function TextField(props: TextFieldProps) {
    const submitHandler = (e: FormEvent<HTMLFormElement>) => {
        if (props.suppressEnterSubmit) {
            e.preventDefault();
        }
    }

    return <Form className={props.className ? "" : "text-field-input"} onSubmit={submitHandler}>
        {(props.label || props.required) && <Row>
            <Col>
                <Form.Label>
                    {props.label}
                    {props.required ?
                        <span className="required">*</span>
                        :
                        <span>&nbsp;</span>
                    }
                </Form.Label>
            </Col>
        </Row>}
        <Row>
            <Col>
                {props.errMsg && <span className="alert-icon"></span>}
                {props.multiline ?
                    <textarea
                        className={props.className ? props.className : (props.errMsg ? `inputError input-field` : `input-field`)}
                        placeholder={props.placeholder}
                        maxLength={props.maxLength}
                        onChange={e => props.onChange(e.target.value)}
                        onInput={e => props.onChange((e.target as HTMLTextAreaElement).value)}
                        onBlur={props.onBlur}
                        disabled={props.disabled}
                        value={props.value}
                    >
                    </textarea>
                    :
                    <Form.Control
                        className={props.className ? props.className : (props.errMsg ? `inputError input-field` : `input-field`)}
                        placeholder={props.placeholder}
                        maxLength={props.maxLength}
                        onChange={e => props.onChange(e.target.value)}
                        onInput={e => props.onChange((e.target as HTMLInputElement).value)}
                        value={props.value}
                        type={"text"}
                        onBlur={props.onBlur}
                        disabled={props.disabled}
                    />
                }
            </Col>
        </Row>
        {props.errMsg && <Row>
            <Col>
                {props.errMsg === "At least one value is required to search." ?
                    <div className="error-message phone-fax-email-error-message">{props.errMsg}</div>
                    :
                    <span className="error-message">{props.errMsg}</span>
                }
            </Col>
        </Row>}
    </Form>
}
